// observacoes-layout-01 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "Adicionar observação": "Agregar observación",
    "Nova observação": "Nueva observación",
};

export default catalogo;
